<template>
  <div class="px-4">
    <div class="row mb-2">
      <div class="col-6">
        <div class="d-flex align-items-center">
          <span class="mr-2">Tài khoản:</span>
          <DxSelectBox
              :data-source="listTDV"
              value-expr="ID"
              display-expr="ID"
              v-model="tdv"
              class="col-4 h-25"
              @value-changed="handleChangeTDV"
              :search-enabled="true"
              :search-expr="['ID']"
          />
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <h4 >Chữ ký hiện tại</h4>
            <img :src="'data:image/png;base64,'+currentSignature" v-if="currentSignature" alt="" class="w-100">
            <p v-else class="text-primary font-weight-bold font-medium-3">Tài khoản chưa có chữ ký</p>
          </div>
        </div>
      </div>

<!--      <input type="text" class="form-control col-4" v-model="tdv" placeholder="Nhập tài khoản">-->
<!--      <input type="file" class="ml-2 form-control col-4" accept="image/*" @change="handleChangeFile">-->
                        <div class="col-6 border p-1 rounded-lg">
                          <VueSignaturePad
                            width="100%"
                            height="50vh"
                            ref="handWriteAdmin"
                            :options="options"
                          />
                          <div class="d-flex justify-content-center w-100 my-2 font-medium-2">
                            Chữ ký Admin
                          </div>
                          <div class="row justify-content-center">
                            <button class="btn btn-primary" @click="clearSign()">Ký lại</button>
                            <button class=" btn btn-primary ml-2" @click="changeSignature">Xác nhận</button>
                          </div>
                        </div>
    </div>
  </div>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import { DxSelectBox } from 'devextreme-vue/select-box';
export default {
  name: "ChangeSignature",
  components: {
    DxSelectBox
  },
  data() {
    return {
      file: null,
      tdv: "",
      listTDV: [],
      currentSignature: "",
      options: {
        penColor: "rgb(56, 63, 255)",
        backgroundColor: "white"
      },
    };
  },
  mounted() {
    this.getListDTV();
  },
  methods: {
    clearSign() {
      this.$refs.handWriteAdmin.clearSignature();
    },
    handleChangeFile(e) {
      e.preventDefault();
      const file = e.target.files ? e.target.files[0] : null;
      if (!file) {
        return;
      }
      if (!file.type.includes('image')) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "File không đúng định dạng!",
            icon: "AlertTriangleIcon",
            variant: "error"
          }
        });
        return;
      }
      const reader = new FileReader();
      reader.onload = async (e) => {
        const bstr = e.target.result;
        this.file = bstr;
      };
      reader.readAsDataURL(file);
    },
    changeSignature() {
      if(!this.tdv || this.$refs.handWriteAdmin.isEmpty()) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng nhập đủ thông tin!",
            icon: "AlertTriangleIcon",
            variant: "error"
          }
        });
        return;
      }
      this.loading(true)
      useJwt.post("update_sign", {
        id: this.tdv,
        img: this.$refs.handWriteAdmin.saveSignature('image/jpeg').data.replace("data:image/png;base64,", "").replace("data:image/jpeg;base64,", "").replace("data:image/jpg;base64,", "")
      }).then(res=>{
        this.loading(false)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Thay đổi chữ ký thành công!",
            icon: "CheckSquareIcon",
            variant: "success"
          }
        });
      }).catch(err=>{
        this.loading(false)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Thay đổi chữ ký thất bại!",
            icon: "AlertTriangleIcon",
            variant: "error"
          }
        });
      })
    },
    getListDTV() {
      useJwt.get("get_list_user_sign").then(res=>{
        this.listTDV = res.data.result;
        // console.log(res.data.result);
      }).catch(err=>{
        console.log(err);
      })
    },
    handleChangeTDV(e) {
      this.currentSignature = "";
      const currentTDV = this.listTDV.find(item=>item.ID === e.value);
      // if(currentTDV && currentTDV.is_sign===1) {
        useJwt.get("get_sign/"+e.value).then(res=>{
          if(res.data.result.length === 0) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.tdv+ " chưa có chữ ký!",
                icon: "AlertTriangleIcon",
                variant: "danger"
              }
            });
            return;
          }
          this.currentSignature = res.data.result[0].SIGN;
        }).catch(err=>{
          console.log(err);
        })
      // }

    }
  },

}
</script>
<style scoped lang="scss">

</style>
